/**
 * 資料確認頁面
 */
import usePersistFunc from '@/hooks/usePersistFunc';
import React from 'react';
import { stepInfo, StepType } from '@/utils/FosterServiceConf';
import type { StepInfoType } from '../../types/defs';
import ApplicantInformations from '../ApplicantInformations';
import FormInfo from '../FormInfo';
import styles from './DataCheck.less';

interface DataCheckProps {}

const DataCheck = (props: DataCheckProps) => {
  // 渲染對應步驟組件
  const renderStep: (currentStep: StepInfoType) => React.ReactNode = usePersistFunc(
    (currentStep: StepInfoType) => {
      let res: React.ReactNode;
      switch (currentStep.stepType) {
        case StepType.form:
          res = <FormInfo isDetail />;
          break;
        default:
          res = null;
      }
      return res;
    },
  );

  return (
    <div className={styles.root}>
      {/* 申請人資料 */}
      <ApplicantInformations />
      {/* 用戶填寫的申请资料信息 */}
      {stepInfo.map(item => renderStep(item))}
    </div>
  );
};

export default DataCheck;
